import initEmailFilter from './initEmailFilter';
import initPhoneMask from './initPhoneMask';
import initCitySearch from './initCitySearch';
import initRocket from './initRocket';

export default async function initFormControls() {
    return Promise.all([
        initEmailFilter('input[type="email"]'),
        initPhoneMask('input[type="phone"]'),
        (window.top.BX || BX).SaleLocationSelectorSearch.init(),
        initRocket(),
    ]);
}
